export default __webpack_public_path__ + "static/media/10.cb19ccc9.png";